import Loader from 'components/Common/Loader';
import React, {FC, useEffect, useMemo, useRef, useState} from 'react';

import './styles.scss';
import heinekenLogo from 'assets/img/match-field-sponsor-heineken.png';
import heinekenLogoGreen from 'assets/img/match-field-sponsor-heineken-green.png';
import heinekenLogoSides from 'assets/img/match-field-sponsor-sides-heineken.png';
import mapeiLogo from 'assets/img/match-field-sponsor-mapei.jpg';
import stoiximanLogoTransparent from 'assets/img/stoiximan_icon.png';
import stoiximanLogo from 'assets/img/share_stoiximan_01.jpg';
import stoiximanLogoSvg from 'assets/img/stoiximan-logo-blue.svg';
import {LmtSponsor} from "utils/types";

interface Props {
    srId: string;
    seasonId?: string;
    lmtSponsor?: LmtSponsor;
}

interface Sponsorship {
    panelLogo?: string;
    goalBannerLogo?: string;
    pitchLogo?: string;
    url?: string;
    /* startDate: string;
     endDate: string; */
}

const isTodaySponsored = (startDate?: string, endDate?: string): boolean => {
    if (!startDate || !endDate) return false;

    const today = new Date();
    const startDay = new Date(startDate);
    const endDay = new Date(endDate);

    return startDay <= today && today <= endDay;
};

/* const widgetInit = (matchId: string, widget: HTMLElement, seasonId?: string) => {
    if (!window.SIR) return;

    const sponsorships: Record<string, Sponsorship> = {
        'sr:season:58428': {
            panelLogo: heinekenLogoGreen,
            goalBannerLogo: heinekenLogoSides,
            pitchLogo: heinekenLogo,
            startDate: '2021-06-10',
            endDate: '2021-07-11',
        }, // NBA
        'sr:season:85502': {
            panelLogo: mapeiLogo,
            goalBannerLogo: mapeiLogo,
            pitchLogo: mapeiLogo,
            startDate: '2021-07-09',
            endDate: '2022-07-31',
        }, // NBA Pre-season
        'sr:season:87230': {
            panelLogo: mapeiLogo,
            goalBannerLogo: mapeiLogo,
            pitchLogo: mapeiLogo,
            startDate: '2021-10-13',
            endDate: '2021-11-30',
        },
        'sr:season:85414': {
            panelLogo: stoiximanLogo,
            goalBannerLogo: stoiximanLogo,
            pitchLogo: stoiximanLogoSvg,
            startDate: '2021-09-16',
            endDate: '2022-05-30',
        },
        'sr:season:84226': {
            panelLogo: stoiximanLogo,
            goalBannerLogo: stoiximanLogo,
            pitchLogo: stoiximanLogoSvg,
            startDate: '2021-09-16',
            endDate: '2022-05-30',
        },
        'sr:season:83926': {
            panelLogo: stoiximanLogo,
            goalBannerLogo: stoiximanLogo,
            pitchLogo: stoiximanLogoSvg,
            startDate: '2021-09-16',
            endDate: '2022-05-30',
        },
        'sr:season:84222': {
            panelLogo: stoiximanLogo,
            goalBannerLogo: stoiximanLogo,
            pitchLogo: stoiximanLogoSvg,
            startDate: '2021-09-16',
            endDate: '2022-05-30',
        },
        'sr:season:80092': {
            panelLogo: stoiximanLogo,
            goalBannerLogo: stoiximanLogo,
            pitchLogo: stoiximanLogoSvg,
            startDate: '2021-09-16',
            endDate: '2022-05-30',
        }
    }; */

const widgetInit = (matchId: string, widget: HTMLElement, seasonId?: string, lmtSponsor?: LmtSponsor) => {
    if (!window.SIR) return;

    window.SIR('addWidget', widget, 'match.lmtPlus', {
        disablePitchStripes: true,
        disablePitchOverlay: true,
        disableWidgetHeader: true,
        disablePitch: true,
        tabs: {
            1: ['statistics'], // soccer
            // 2: ['lineups'],  basketball
        },
        scoreboard: 'disable',
        collapseTo: 'disable',
        momentum: "disable",
        expanded: true,
        detailedScoreboard: true,
        tabsPosition: 'disable',
        matchId,
        onTrack: (event: string, data: any) => {
            if (event === 'license_error' && window.SIR) window.SIR('removeWidget', widget);
        },
    });
};

const WidgetSrStats: FC<Props> = ({srId, seasonId, lmtSponsor}: Props) => {
    const placeholder = useRef<HTMLDivElement>(null);
    const id = useMemo(() => {
        const match = srId.match(/sr:(?:sport_event|match):(\d+)/);

        if (match && match.length > 1) return match[1];

        return '';
    }, [srId]);

    useEffect(() => {
        const widget = placeholder.current;

        if (widget) {
            if (!window.SIR) {
                const script = document.createElement('script');
                script.src =
                    'https://widgets.sir.sportradar.com/cdeefc940eb423238996bef169bcfa23/widgetloader';
                script.async = true;
                script.setAttribute('data-sr-theme', 'false');
                script.setAttribute('data-sr-language', 'el');
                script.onload = () => {
                    widgetInit(id, widget, seasonId, lmtSponsor);
                };
                document.head.appendChild(script);
            } else {
                widgetInit(id, widget, seasonId, lmtSponsor);
            }
        }

        return () => {
            if (widget && window.SIR) window.SIR('removeWidget', widget);
        };
    }, [seasonId, id, placeholder]);

    return id ? (
        <div className="WidgetSrStats">
            <div className="WidgetSrStats__widget" id="sr-widget" ref={placeholder}>
                <Loader/>
            </div>
        </div>
    ) : null;
};

export default WidgetSrStats;
